import React from "react";
import refrigerator1 from "./refrigerator-img/refrigerator-1.jpeg";
import refrigerator2 from "./refrigerator-img/refrigerator-19.jpeg";
import refrigerator3 from "./refrigerator-img/refrigerator-3.jpeg";
import refrigerator4 from "./refrigerator-img/refrigerator-4.jpeg";
import refrigerator5 from "./refrigerator-img/refrigerator-5.jpeg";
import refrigerator6 from "./refrigerator-img/refrigerator-6.jpeg";
import refrigerator7 from "./refrigerator-img/refrigerator-7.jpeg";
import refrigerator8 from "./refrigerator-img/refrigerator-8.jpeg";
import refrigerator9 from "./refrigerator-img/refrigerator-9.jpeg";
import refrigerator10 from "./refrigerator-img/refrigerator-10.jpeg";
import refrigerator11 from "./refrigerator-img/refrigerator-11.jpeg";
import refrigerator12 from "./refrigerator-img/refrigerator-12.jpeg";
import refrigerator13 from "./refrigerator-img/refrigerator-13.jpeg";
import refrigerator14 from "./refrigerator-img/refrigerator-14.jpeg";
import refrigerator15 from "./refrigerator-img/refrigerator-15.jpeg";
import refrigerator16 from "./refrigerator-img/refrigerator-16.jpeg";
import refrigerator17 from "./refrigerator-img/refrigerator-17.jpeg";
import refrigerator18 from "./refrigerator-img/refrigerator-18.jpeg";

const Refrigerator = [
  {
    id: 1,
    img: refrigerator1,
    name: "Godrej 180 L",
    color: "Maple Blue",
    price: "₹14,490",
  },
  {
    id: 2,
    img: refrigerator2,
    name: "Godrej 234 L",
    color: "Marine Blue",
    price: "₹19,290",
  },
  {
    id: 3,
    img: refrigerator3,
    name: "Godrej 244 L",
    color: "Steel Glow",
    price: "₹24,990",
  },
  {
    id: 4,
    img: refrigerator4,
    name: "Godrej 234 L",
    color: "Fossil Steel",
    price: "₹12,490",
  },
  {
    id: 5,
    img: refrigerator5,
    name: "Godrej 244 L",
    color: "Mystic Blue",
    price: "₹12,490",
  },
  {
    id: 6,
    img: refrigerator6,
    name: "Godrej 180 L",
    color: "Mystic Wine",
    price: "₹15,990",
  },
  {
    id: 7,
    img: refrigerator7,
    name: "Godrej 234 L",
    color: "Steel Rush",
    price: "₹20,790",
  },
  {
    id: 8,
    img: refrigerator8,
    name: "Godrej 250 L",
    color: "Floral Blue",
    price: "₹17,990",
  },
  {
    id: 9,
    img: refrigerator9,
    name: "Godrej 180 L",
    color: "Aqua Wine",
    price: "₹14,490",
  },
  {
    id: 10,
    img: refrigerator10,
    name: "Godrej 235 L",
    color: "Maple Blue",
    price: "₹14,490",
  },
  {
    id: 11,
    img: refrigerator11,
    name: "Godrej 180 L",
    color: "Marine Blue",
    price: "₹17,990",
  },
  {
    id: 12,
    img: refrigerator12,
    name: "Godrej 180 L",
    color: "Steel Glow",
    price: "₹16,490",
  },
  {
    id: 13,
    img: refrigerator13,
    name: "Godrej 244 L",
    color: "Fossil Steel",
    price: "₹16,490",
  },
  {
    id: 14,
    img: refrigerator14,
    name: "Godrej 234 L",
    color: "Maple Wine",
    price: "₹17,990",
  },
  {
    id: 15,
    img: refrigerator15,
    name: "Godrej 180 L",
    color: "Red",
    price: "₹22,490",
  },
  {
    id: 16,
    img: refrigerator16,
    name: "Godrej 185 L",
    color: "Berry Blue",
    price: "₹17,990",
  },
  {
    id: 17,
    img: refrigerator17,
    name: "Godrej 180 L",
    color: "Fusion Blue",
    price: "₹16,490",
  },
  {
    id: 18,
    img: refrigerator18,
    name: "Godrej 234 L",
    color: "Marine Blue",
    price: "₹17,990",
  },
];

export default Refrigerator;
